import { render, staticRenderFns } from "./FireQuotePosted.vue?vue&type=template&id=d2a4afc2&"
import script from "./FireQuotePosted.vue?vue&type=script&lang=js&"
export * from "./FireQuotePosted.vue?vue&type=script&lang=js&"
import style0 from "./FireQuotePosted.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "FireQuotePosted.vue"
export default component.exports